export const navItems = [
  { id: 'flash', label: '风向快讯' },
  { id: 'stance', label: '网友站队' },
  { id: 'reversal', label: '舆论反转' },
  { id: 'focus', label: '争议焦点' },
  { id: 'pr', label: '公关动作' },
  { id: 'faq', label: '常见问题' },
];

export const flashItems = [
  {
    time: '09:12',
    tag: '态度转向',
    title: '「选秀旧照」事件评论区风向松动，质疑声首次低于支持声',
    desc: '凌晨起，最初嘲讽为主的评论区出现大量「先看完完整视频再判断」的留言，网友评论结构正在发生变化。',
    heat: '热度 8.7 万',
    tone: 'rise',
  },
  {
    time: '08:40',
    tag: '评论区炸锅',
    title: '「直播话术」争议新增两段录屏，站队情况出现明显分裂',
    desc: '新增录屏被指掐头去尾，支持方与质疑方各自截取片段互相举证，中立围观人数快速上升。',
    heat: '热度 6.3 万',
    tone: 'split',
  },
  {
    time: '07:55',
    tag: '公关动作',
    title: '当事工作室发布 300 字声明，未回应核心争议焦点',
    desc: '声明强调「保留法律追责权利」，但网友最关心的分成与署名问题均未提及，被指避重就轻。',
    heat: '热度 5.1 万',
    tone: 'pr',
  },
  {
    time: '06:20',
    tag: '舆论反转',
    title: '「剧集替身」爆料被原作者否认，昨日的定论出现反转',
    desc: '最初爆料的账号删除原帖，此前一边倒的批评声开始被「等实锤」言论稀释，态度分析随之更新。',
    heat: '热度 4.4 万',
    tone: 'flip',
  },
  {
    time: '04:05',
    tag: '低热度长尾',
    title: '「代言下架」话题热度回落，讨论转向上游合约细节',
    desc: '大众关注度下降，只剩少数专业网友仍在跟进品牌方的合同条款与解约成本。',
    heat: '热度 1.2 万',
    tone: 'calm',
  },
];

export const stanceTopics = [
  {
    title: '选秀旧照风波',
    heat: '8.7 万',
    total: 12480,
    support: 46,
    doubt: 38,
    neutral: 16,
    trend: 'up',
    trendText: '支持声较昨日 +11%',
  },
  {
    title: '直播话术争议',
    heat: '6.3 万',
    total: 9260,
    support: 39,
    doubt: 44,
    neutral: 17,
    trend: 'down',
    trendText: '质疑声较昨日 +6%',
  },
  {
    title: '剧集替身爆料',
    heat: '4.4 万',
    total: 7180,
    support: 33,
    doubt: 31,
    neutral: 36,
    trend: 'flat',
    trendText: '中立比例继续扩大',
  },
];

export const reversalEvents = [
  {
    stage: '起点',
    time: '9 月 9 日 21:00',
    title: '首条爆料帖出现',
    desc: '一条未标注出处的图文帖迅速扩散，网友评论以「太失望」为主，站队情况几乎一边倒。',
    side: 'doubt',
  },
  {
    stage: '爆发',
    time: '9 月 10 日 10:30',
    title: '截图被二次搬运，站队被推向极端',
    desc: '经过多轮搬运后原始语境丢失，评论区开始出现对当事人与其工作室的双向指责。',
    side: 'doubt',
  },
  {
    stage: '松动',
    time: '9 月 11 日 16:45',
    title: '当事人放出完整视频片段',
    desc: '完整片段显示爆料存在剪辑问题，首批质疑者开始道歉，舆论反转迹象第一次变得明显。',
    side: 'neutral',
  },
  {
    stage: '反转',
    time: '9 月 12 日 09:12',
    title: '爆料账号删帖，风向正式掉头',
    desc: '原爆料账号删除内容，网友态度分析显示支持声首次反超质疑声，围观者转向追问爆料动机。',
    side: 'support',
  },
];

export const focusPoints = [
  {
    icon: 'ri-question-answer-line',
    title: '实锤还是剪辑？',
    desc: '网友争论最集中的一点：现有素材是否经过掐头去尾，能否作为完整证据链。',
    count: '争议评论 3,240 条',
  },
  {
    icon: 'ri-scales-3-line',
    title: '分成与署名',
    desc: '涉及利益分配的核心问题始终未被正面回应，是质疑方最不肯松口的地方。',
    count: '争议评论 2,180 条',
  },
  {
    icon: 'ri-emotion-line',
    title: '回应态度是否真诚',
    desc: '声明用词被逐字解读，网友普遍认为语气过于强硬，反而加重了负面观感。',
    count: '争议评论 1,760 条',
  },
  {
    icon: 'ri-user-voice-line',
    title: '爆料者的动机',
    desc: '反转之后讨论重心开始转移，越来越多人追问最初爆料是谁在推动、图什么。',
    count: '争议评论 1,120 条',
  },
];

export const prActions = [
  {
    time: '9 月 12 日 07:55',
    type: '书面声明',
    title: '工作室发布声明强调法律追责',
    effect: '负面',
    effectNote: '被指回避核心，质疑声反升',
    icon: 'ri-file-text-line',
  },
  {
    time: '9 月 11 日 22:10',
    type: '物料释出',
    title: '放出完整花絮片段自证',
    effect: '正面',
    effectNote: '促成首次舆论松动',
    icon: 'ri-film-line',
  },
  {
    time: '9 月 11 日 14:00',
    type: '沉默',
    title: '热搜期间保持 12 小时不回应',
    effect: '中性',
    effectNote: '给了爆料充分扩散时间',
    icon: 'ri-timer-line',
  },
  {
    time: '9 月 10 日 19:20',
    type: '粉丝沟通',
    title: '后援会呼吁理性，避免拉踩',
    effect: '中性',
    effectNote: '未明显改变站队比例',
    icon: 'ri-megaphone-line',
  },
];

export const trustPoints = [
  {
    icon: 'ri-filter-3-line',
    title: '先看立场再看结论',
    desc: '每条热点都标注支持、质疑与中立的比例，避免被单一声音带着走。',
  },
  {
    icon: 'ri-time-line',
    title: '保留完整时间线',
    desc: '舆论反转往往发生在几小时内，我们按时间顺序还原态度变化，而不是只留截图。',
  },
  {
    icon: 'ri-eye-line',
    title: '只汇总，不站队',
    desc: '黑料热点不生产爆料、不替任何人定性，只把公开可见的网友评论与动态摆在一起。',
  },
];

export const faqItems = [
  {
    q: '黑料热点会自己爆料吗？',
    a: '不会。本站不生产爆料也不做定性，只把已经公开传播的网友评论、站队情况与公关动作汇总成可读的立场分布与时间线，最终判断请交给你自己。',
  },
  {
    q: '站队情况里的比例是怎么来的？',
    a: '根据同一话题下公开评论区中表态支持、提出质疑与保持中立的发言数量粗略估算，仅用于反映大致风向，不构成对任何一方的结论。',
  },
  {
    q: '舆论反转是怎么判定的？',
    a: '当同一话题的支持与质疑比例出现方向性变化，并伴随新的公开素材或回应时，我们会把它标记为一次反转，并在时间轴中保留前后对比。',
  },
  {
    q: '为什么同一事件热度会突然掉下来？',
    a: '热点通常有生命周期，公关动作、新话题出现或爆料停止更新都会让关注度回落，热度下降本身也是判断风向的一个信号。',
  },
];